module.exports = __webpack_public_path__ + "img/bg_wooriwon.e78ec17.png";